import * as React from 'react';
// import Toggle from '../../../common/form/Toggle';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import { availableTimeslots } from '../../../../utilities/timeslots';
import { TourInterval } from '../../../../api/Property';
import CheckboxLabeled from '../../../common/form/CheckboxLabeled';

interface State {
    storedStartTime: string;
    storedEndTime: string;
}

interface Props {
    interval: TourInterval;
    intervalName: string;
    dayName: string;
    defaultStart: string;
    defaultEnd: string;
    onChange: (newValue: TourInterval) => void;
    isDisabled: boolean;
}

class TourIntervalConfigurationSection extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            storedStartTime: this.props.interval.startTime,
            storedEndTime: this.props.interval.endTime
        };

        this.handleChange = this.handleChange.bind(this);
        
    }

    render() {
        let startTime = this.props.interval && this.props.interval.startTime;
        let endTime = this.props.interval && this.props.interval.endTime;
        let blockedStartTime = this.props.interval && this.props.interval.blockedStartTime;
        let blockedEndTime = this.props.interval && this.props.interval.blockedEndTime;
        let timeSelectOptions = availableTimeslots.map(slot => ({
            value: slot,
            label: slot
        }));
        let idPrefix = `${this.props.dayName}-${this.props.intervalName}`;
        // console.log(this.props.interval.toursEnabled);

        const handleRadioClick = (answer:boolean) => {
            if(answer) {
                this.setState({
                    storedStartTime: startTime!,
                    storedEndTime: endTime!
                });                                    
                this.props.onChange({
                    ...this.props.interval,
                    toursEnabled: true
                });
            } else {
                this.props.onChange({
                    ...this.props.interval,
                    toursEnabled: false
                });
            }
        };

        return (
            <>
                <div className="row">
                    <div className="col-6 font-weight-bold">Tour24 Hours Available</div>
                    <div className="col-6 tour-config-section-yes-no-toggle-wrapper" style={{display:'flex', alignItems:'center', marginBottom:'15px'}}>
                        <div className="tour-enable-radio-btn-wrapper">    
                            <div className="custom-radio-wrapper"
                            style={{ pointerEvents: this.props.isDisabled ? 'none' : 'auto' }}
                            >
                                <div                                
                                    className="custom-radio-circle"
                                    onClick={() => handleRadioClick(true)}
                                >   
                                    {this.props.interval.toursEnabled &&
                                        <div className="custom-radio-selected"/>                                
                                       
                                    }
                                </div>
                                <div className="custom-radio-label">Yes</div>
                                <div
                                    className="custom-radio-circle"  
                                    onClick={() => handleRadioClick(false)}                          
                                >   
                                    {!this.props.interval.toursEnabled &&
                                        <div className="custom-radio-selected"/>                                
                                    }
                                </div>
                                <div className="custom-radio-label">No</div>     
                            </div>                                      
                            
                        </div>
                    </div>
                </div>
                    <>
                        <div className="form-group row">
                            <FormSelectLabeled
                                labelProps={{
                                    labelText: 'Start'
                                }}
                                selectProps={{
                                    id: `${idPrefix}-tour-start-time`,
                                    name: 'startTime',
                                    value: startTime,                     
                                    disabled: this.props.isDisabled || this.props.interval.toursEnabled === false,
                                }}
                                selectOptions={timeSelectOptions}
                                onChange={this.handleChange}
                                className="col-6"                                
                            />
                            <FormSelectLabeled
                                labelProps={{
                                    labelText: 'End'
                                }}
                                selectProps={{
                                    id: `${idPrefix}-tour-end-time`,
                                    name: 'endTime',
                                    value: endTime,                
                                    disabled: this.props.isDisabled || this.props.interval.toursEnabled === false,
                                }}
                                selectOptions={timeSelectOptions}
                                onChange={this.handleChange}
                                className="col-6"
                            />
                        </div>
                        <CheckboxLabeled
                            labelProps={{
                                labelText: 'Disable tours for window during time range?'
                            }}
                            inputProps={{
                                name: 'disabledWindowCheckbox',
                                id: `${idPrefix}-tours-disabled-checkbox`,
                                checked: this.props.interval.blockedTimeEnabled,
                                disabled: this.props.isDisabled || this.props.interval.toursEnabled === false,
                            }}
                            onChange={(inputName, newValue) =>
                                this.props.onChange({
                                    ...this.props.interval,
                                    blockedTimeEnabled: newValue
                                })
                            }
                            controlCssClass="small-inline-label"
                        />
                        {this.props.interval.blockedTimeEnabled && (
                            <div className="form-group row">
                                <FormSelectLabeled
                                    labelProps={{
                                        labelText: 'Disable Tours From...'
                                    }}
                                    selectProps={{
                                        id: `${idPrefix}-tour-blocked-start-time`,
                                        name: 'blockedStartTime',
                                        value: blockedStartTime,
                                        disabled: this.props.isDisabled || this.props.interval.toursEnabled === false,
                                    
                                    }}
                                    selectOptions={timeSelectOptions}
                                    onChange={this.handleChange}
                                    className="col-6"
                                />
                                <FormSelectLabeled
                                    labelProps={{
                                        labelText: '...To'
                                    }}
                                    selectProps={{
                                        id: `${idPrefix}-tour-blocked-end-time`,
                                        name: 'blockedEndTime',
                                        value: blockedEndTime,
                                        disabled: this.props.isDisabled || this.props.interval.toursEnabled === false,
                                    }}
                                    selectOptions={timeSelectOptions}
                                    onChange={this.handleChange}
                                    className="col-6"
                                />
                            </div>
                        )}
                    </>           
            </>
        );
    }

    handleChange(name: string, value: any) {
        this.props.onChange({ ...this.props.interval, [name]: value });
    }
}

export default TourIntervalConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/TourIntervalConfigurationSection.tsx